// extracted by mini-css-extract-plugin
module.exports = {"tag":"RelatedArticleLinks_tag__3TCAB","primary":"RelatedArticleLinks_primary__GYRxp","linksContainer":"RelatedArticleLinks_linksContainer__ZQazF"};